import { render, staticRenderFns } from "./zyDetail.vue?vue&type=template&id=fb16dcec&scoped=true"
import script from "./zyDetail.vue?vue&type=script&lang=js"
export * from "./zyDetail.vue?vue&type=script&lang=js"
import style0 from "./zyDetail.vue?vue&type=style&index=0&id=fb16dcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb16dcec",
  null
  
)

export default component.exports